import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { styled } from 'styled-components';
import { Avatar } from '@design-system/avatar';
import { Box } from '@design-system/box';
import { Dotdotdot } from '@design-system/dotdotdot';
import { LikesAndCommentsIcons } from './LikesAndCommentsIcons';
const DEFAULT_DISPLAY_FIELDS = {
    contentType: false,
    comments: false,
    likes: false,
};
export const TrendingPresentation = ({ data: { comments, icon, likes, title, type }, displayFields = DEFAULT_DISPLAY_FIELDS, onClick, }) => {
    const [cardHovered, setCardHovered] = useState(false);
    const clickableProps = useMemo(() => onClick && {
        onClick,
        onMouseEnter: () => setCardHovered(true),
        onMouseLeave: () => setCardHovered(false),
    }, [onClick]);
    return (_jsxs(TrendingPresentationCard, Object.assign({}, clickableProps, { "data-testid": "trending-presentation", children: [_jsxs(Box, { alignItems: "center", children: [_jsx(Box, { flex: "none", height: "40px", width: "40px", children: _jsx(Avatar, { alt: "", src: icon }) }), _jsxs(Box, { flexDirection: "column", ml: 3, children: [_jsx(Box, { font: "body-semibold-asphalt", children: type }), _jsx(Title, { "$cardHovered": cardHovered, children: _jsx(Dotdotdot, { clamp: 1, children: title }) })] })] }), (displayFields.comments || displayFields.likes) && (_jsx(LikesAndCommentsIcons, { comments: comments, displayComments: displayFields.comments, displayLikes: displayFields.likes, likes: likes }))] })));
};
const TrendingPresentationCard = styled(Box).attrs(() => ({
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
})) `
  &:hover,
  &:focus {
    cursor: pointer;
  }
`;
const Title = styled(Box) `
  color: ${({ $cardHovered, theme }) => $cardHovered ? theme.colors.link : 'inherit'};
  text-decoration: ${({ $cardHovered }) => $cardHovered ? 'underline' : 'none'};
`;
//# sourceMappingURL=TrendingPresentation.js.map